module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Todas as ações de extensão devem ter como membros da equipe de trabalho estudantes de graduação e/ou pós-graduação. Caso seja necessário, o coordenador poderá cadastrá-los após a aprovação da ação.\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-right": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Mostrar integrantes inativos"
    },
    model: {
      value: (_vm.mostrarInativos),
      callback: function($$v) {
        _vm.mostrarInativos = $$v
      },
      expression: "mostrarInativos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaIntegrantes,
      "search": _vm.search,
      "custom-filter": _vm.filtroInativos,
      "no-data-text": 'Este projeto não possui integrantes.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [(_vm.verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false && (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true)) ? _c('div', [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('router-link', {
          class: props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2',
          attrs: {
            "to": {
              name: 'EditarIntegrante',
              params: {
                idProjeto: _vm.idProjeto,
                idParticipante: props.item.idParticipante
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")]) : _c('router-link', {
          class: props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2',
          attrs: {
            "to": {
              name: 'VisualizarIntegrante',
              params: {
                idProjeto: _vm.idProjeto,
                idParticipante: props.item.idParticipante
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor, props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false) ? _c('div', [(_vm.usuarioPROEX === true || _vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "history",
            "color": "primary",
            "tooltip": "Histórico do integrante"
          },
          on: {
            "click": function($event) {
              return _vm.toOcorrenciasIntegrante(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao != null && props.item.funcao.item === 1)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "autorenew",
            "color": "primary",
            "tooltip": "Trocar coordenador",
            "disabled": _vm.administrador === false,
            "disabled-tooltip": "Somente o administrador pode alterar o coordenador"
          },
          on: {
            "click": function($event) {
              return _vm.toTrocarCoordenacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao === 'A')) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "transfer_within_a_station",
            "color": "primary",
            "tooltip": "Finalizar participação"
          },
          on: {
            "click": function($event) {
              return _vm.toEncerrarParticipacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao !== 'A')) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "undo",
            "color": "primary",
            "tooltip": "Reativar participação"
          },
          on: {
            "click": function($event) {
              return _vm.toReativarParticipacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "disabled": props.item.funcao != null && props.item.funcao.item === 1,
            "tooltip": "Excluir integrante",
            "disabled-tooltip": "O coordenador não pode ser excluído"
          },
          on: {
            "click": function($event) {
              return _vm.excluirIntegrante(props.item.idParticipante)
            }
          }
        }) : _vm._e()], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaIntegrantes.length) + " integrantes\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": this.controlaBotaoAvancar(),
      "editar": "NovoIntegrante",
      "nome_editar": "Novo integrante",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": this.botaoFinalizarAcao
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7db5a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-integrantes-tabela.vue
// module id = 479
// module chunks = 0